import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footers = styled.div`
  width: 100%;
  display: flex;
  background: #17120d;
`;

export default function Footer() {
  const authMember = null;

  return (
    <Footers className={"booksaw-footer"}>
      <Container>
        <Stack className={"footer-cta"}>
          <Box>
            <span>Booksaw club</span>
            <h2>Keep discovering books worth finishing.</h2>
          </Box>
          <Link to="/products">Browse shelves</Link>
        </Stack>

        <Stack className={"footer-main"}>
          <Stack className={"footer-brand"}>
            <img src={"/icons/Booksaw.svg"} alt="Booksaw" />
            <Box className={"foot-desc-txt"}>
              Curated books, thoughtful recommendations, and a simple shopping
              experience for every reader.
            </Box>
            <Box className="sns-context">
              <a href="/" aria-label="Facebook">
                <img src={"/icons/facebook.svg"} alt="" />
              </a>
              <a href="/" aria-label="Twitter">
                <img src={"/icons/twitter.svg"} alt="" />
              </a>
              <a href="/" aria-label="Instagram">
                <img src={"/icons/instagram.svg"} alt="" />
              </a>
              <a href="/" aria-label="Youtube">
                <img src={"/icons/youtube.svg"} alt="" />
              </a>
            </Box>
          </Stack>

          <Stack className={"footer-columns"}>
            <Stack className={"footer-column"}>
              <Box className={"foot-category-title"}>Explore</Box>
              <Box className={"foot-category-link"}>
                <Link to="/">Home</Link>
                <Link to="/products">Products</Link>
                {authMember && <Link to="/orders">Orders</Link>}
                <Link to="/help">Help</Link>
              </Box>
            </Stack>
            <Stack className={"footer-column"}>
              <Box className={"foot-category-title"}>Support</Box>
              <Box className={"foot-category-link"}>
                <span>Help center</span>
                <span>Report a problem</span>
                <span>Contact us</span>
                <span>24/7 service</span>
              </Box>
            </Stack>
            <Stack className={"footer-column"}>
              <Box className={"foot-category-title"}>Find Us</Box>
              <Box className={"foot-category-link"}>
                <span>Daejeon, Korea</span>
                <span>+82 10 8282 9898</span>
                <span>book@gmail.com</span>
                <span>Always open</span>
              </Box>
            </Stack>
            <Stack className={"footer-column footer-mini-card"}>
              <span>Today’s shelf</span>
              <strong>Bestsellers, kids books, and self-growth picks.</strong>
              <Link to="/products">Start browsing</Link>
            </Stack>
          </Stack>
        </Stack>

        <Stack className={"footer-bottom"}>
          <span>© Booksaw — all rights reserved.</span>
          <span>Designed for readers.</span>
        </Stack>
      </Container>
    </Footers>
  );
}
